module.exports = __webpack_public_path__ + "img/img_productDisplay.f0fdc7f1.png";